// @ts-strict-ignore
import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from "primeng/table";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import { ProgressCheck } from "src/app/shared/models/progress-check.model";
import { SharedDirectivesModule } from "src/app/shared/shared-directives.module";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { DataService } from "src/app/shared/services/data.service";
import * as ProfileModel from "src/app/shared/models/profile.model";
import { GuidanceBoxComponent } from "src/app/modules/esim/shared/components/guidance-box/guidance-box.component";
import { ErrorMessageComponent } from "src/app/modules/esim/shared/components/error-message/error-message.component";

@Component({
  selector: C.EWIZ_DIRECTORY_FILE_CONFIGURATION,
  templateUrl: "./directory-file-configuration.component.html",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    TableModule,
    SharedDirectivesModule,
    GuidanceBoxComponent,
    ErrorMessageComponent
  ]
})
export class EWizDirectoryFileConfigurationComponent extends EWizDynamicBaseClassComponent implements OnInit, ErrorCheck, ProgressCheck {
  constructor(private dataService: DataService) {
    super();
  }

  public selectedDirectoryFiles: ProfileModel.DirectoryFilesDto[] | null = null;

  ngOnInit() {
    this.profileValues.directoryFileVisited = true;
    this.handleFormEvents();
    this.errorCheck(this.profileValues, this.dataService);
  }

  public errorCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    // Always reset error values to default state prior to executing check
    this.errorFound = false;
    this.errorMessage = "";

    if (values.directoryFiles) {
      for (const directoryFile of values.directoryFiles) {
        if (
          !dataService.isNullOrEmpty(directoryFile.applicationIdentifier) &&
          !dataService.validHexValue(directoryFile.applicationIdentifier, 5, 16)
        ) {
          this.errorMessage = $localize`Application Identifier values must be between 5 and 16 HEX bytes in length, and contain an even number of characters`;
          this.errorFound = true;
          return this.errorFound;
        }
      }
      const rfmAidList = values.rfmConfiguration?.map((rfm) => rfm.adfAID)?.filter((aid) => !dataService.isNullOrEmpty(aid || "")) || [];
      const isMatching =
        !rfmAidList.length ||
        rfmAidList.every((rfmAid) => values.directoryFiles.map((file) => file.applicationIdentifier).includes(rfmAid));

      if (!isMatching) {
        this.errorMessage = $localize`Application Identifier values must match ADF AID provided in RFM Configuration`;
        this.errorFound = true;
        return this.errorFound;
      }

      const seen = new Set<string>();
      for (const file of values.directoryFiles) {
        const aid = file.applicationIdentifier?.toLowerCase();
        if (aid && seen.has(aid)) {
          this.errorMessage = $localize`Application Identifier values must be unique`;
          this.errorFound = true;
          return this.errorFound;
        }
        if (aid) seen.add(aid);
      }
    }

    return this.errorFound;
  }

  public progressCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    if (values.directoryFiles) {
      for (const directoryFile of values.directoryFiles) {
        if (dataService.isNullOrEmpty(directoryFile.applicationIdentifier) || dataService.isNullOrEmpty(directoryFile.label)) {
          return false;
        }
      }
    }
    // There must be at least 1 file AID to continue
    return values.directoryFiles?.length > 0;
  }

  public addDirectoryFile() {
    this.profileValues.directoryFiles = [
      ...this.profileValues.directoryFiles,
      {
        id: this.profileValues.directoryFiles.length || 0,
        applicationIdentifier: null,
        label: null
      }
    ];
    this.handleFormEvents();
  }

  public deleteDirectoryFiles() {
    this.profileValues.directoryFiles = [
      ...this.profileValues.directoryFiles
        .filter((file) => !this.selectedDirectoryFiles.includes(file))
        .map((file, index) => ({ ...file, id: index }))
    ];
    this.selectedDirectoryFiles = [];
    this.handleFormEvents();
  }
}
